import axios from 'axios';

const URL = process.env.REACT_APP_API_URL_CM;

const getSessionsList = (search = '', page = 1): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await axios.get(`${URL}/sessions/?search=${search}&page=${page}`);
            resolve(resp);
        } catch(err:any) {
            reject(err)
        }
    });
}

const loadSessionOptions = async (search: string, _loadedOptions: any, additional?: { page: number }) => {
    const page = additional ? additional.page : 1;
    const resp = await getSessionsList(search, page);
    const { results, next } = resp.data;
    return {
        options: results.map((item: any) => ({ label: `${item.id} - ${item.name}`, value: item.id })),
        hasMore: !!next,
        additional: { page: page + 1 },
    };
}

const getSessionOptionById = async (id: string | number): Promise<{ value: number, label: string } | null> => {
    const resp = await getSessionsList(String(id));
    const session = resp.data.results.find((item: any) => String(item.id) === String(id));
    return session ? { value: session.id, label: `${session.id} - ${session.name}` } : null;
}

const bulkCreateSession = (data: any): Promise<any> => {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await axios.post(`${URL}/sessions/bulk_create/`, data);
            resolve(resp);
        } catch(err:any) {
            reject(err)
        }
    });
}

export {
    getSessionsList,
    loadSessionOptions,
    getSessionOptionById,
    bulkCreateSession
}
